import { render, staticRenderFns } from "./JobPortalItem.vue?vue&type=template&id=6d9abdc0&scoped=true"
import script from "./JobPortalItem.vue?vue&type=script&lang=js"
export * from "./JobPortalItem.vue?vue&type=script&lang=js"
import style0 from "./JobPortalItem.vue?vue&type=style&index=0&id=6d9abdc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9abdc0",
  null
  
)

export default component.exports